var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.dataFetch)?_c('div',{staticClass:"front-banner"},_vm._l((_vm.dataList),function(item,index){return _c('div',{key:index,staticClass:"front-banner--items",style:({ 'background-image': 'url(' + item.picture + ')' })})}),0):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }